// extracted by mini-css-extract-plugin
export default {"main":"app_main__nXLxf","main_container":"app_main_container__ak8da"};